
import {
    RELATED_CONCEPTS_SYNONYMS_CHANGE,
    RELATED_CONCEPTS_CHANGE,
    RELATED_CONCEPTS_TERMS_CHANGE,
    RELATED_CONCEPTS_SYNONYMS_REQUEST,
    RELATED_CONCEPTS_REQUEST
 } from '../../actions/types';
 
 const initialState = {
        suggestions: [],
        concepts : [],
        synonyms : [],
        closelyRelatedKeywords:[],
        distantlyRelatedKeywords:[],
        isSuggestionLoading:false,
        isConceptLoading : false
 };
 
 
 
 const setRelatedSuggestions = (state, action) => {
     let suggestions = action.payload.suggestionTerms || [];
     return {
         ...state,
         suggestions,
         isSuggestionLoading:false 
     }
 } 
 
 const setRelatedConcetps = (state, action) => {
    let concepts = action.payload.concepts || [];
    let synonyms = action.payload.synonyms || [];
    
    return {
        ...state,
        concepts,
        synonyms ,
        isConceptLoading : false
    }
} 

const setRelatedSuggestionsRequest = (state, action) => {
    
    return {
        ...state,
        isSuggestionLoading:true,
        concepts : [],
        synonyms : []
    }
} 

const setRelatedConcetpsRequest = (state, action) => {
    return {
        ...state,
        isConceptLoading : true
    }
}

const setTemrs = (state, action) => {
    let distantlyRelatedKeywords = action.payload.distantlyRelatedKeywords || [];
    let closelyRelatedKeywords = action.payload.closelyRelatedKeywords || [];
    
    return {
        ...state,
        distantlyRelatedKeywords,
        closelyRelatedKeywords 
    }
} 



 export default (state = initialState, action) => {
     switch (action.type) {
         case RELATED_CONCEPTS_SYNONYMS_CHANGE:
             return setRelatedSuggestions(state,action);
             break;

        case RELATED_CONCEPTS_CHANGE:
            return setRelatedConcetps(state,action);
            break;
        case RELATED_CONCEPTS_TERMS_CHANGE:
            return setTemrs(state,action)

        case RELATED_CONCEPTS_SYNONYMS_REQUEST:
            return setRelatedSuggestionsRequest(state,action)

        case RELATED_CONCEPTS_REQUEST:
            return setRelatedConcetpsRequest(state,action)

         default:
             return state;
             break;
     }
 }